import React from "react";

const Tooltip = ({ text, children }) => {
  return (
    <div class="tooltip-container">
      {children}
      <div class="tooltip">{text}</div>
      {/* <div class="tooltip">sdfka laskdjf al asdlfoiasfdsa lj aslfudisof  u soidfasiouiofdsa o</div> */}
    </div>
  );
};

export default Tooltip;
